


import globalParam from "@/library/global_param";
import abiService from "@/library/abi_service";
import {defineComponent} from "vue";

export default defineComponent( {
  data() {
    return {
      collapseShow: "hidden",
      testData : 123
    };
  },
  // hint: search Navigation
  methods: {
    inquiryMenuClassAdmin: function () {
      let v = this.testData;
      if (this.isBoldMenu("info2")) {
        return this.colorTwo;
      } else {
        return this.colorOne;
      }
    },
    inquiryMenuClassDashboard: function () {
      if (this.isDashboard()) {
        return this.colorTwo;
      } else {
        return this.colorOne;
      }
    },
    inquiryColorMenu: function (input : string) {
      // console.log("inquiryColorMenu",input)
      if (this.isBoldMenu(input)) {
        return this.colorTwo;
      } else {
        return this.colorOne;
      }
    },
    inquiryMenuClassDemo: function () {
      if (this.isBoldMenu("demo")) {
        return this.colorTwo;
      } else {
        return this.colorOne;
      }
    },
    inquiryMenuClassDocumentation: function () {
      if (this.isBoldMenu("documentation")) {
        return this.colorTwo;
      } else {
        return this.colorOne;
      }
    },
    toggleCollapseShow: function (classes : any) {
      this.collapseShow = classes;
    },
    isBoldMenu(input : string) {
      let url = window.location.href;
      let input2 = input.toString();
      let output = url.toLowerCase().includes(input2);
      return output;
    },
    isDashboard() {
      let url = window.location.href;
      // console.log("current url", url)
      let l = this.getLocation(url)
      // console.log("hostname", l.origin)

      let url2 = this.trimChar(url,"/")
      // console.log("url2", url)
      if (url2 == l.origin) {
        return true;
      } else {
        return false;
      }
    },
    trimChar(string : string, charToRemove : any) {
      while (string.charAt(0) == charToRemove) {
        string = string.substring(1);
      }

      while (string.charAt(string.length - 1) == charToRemove) {
        string = string.substring(0, string.length - 1);
      }

      return string;
    },
    getLocation(href : string) {
      var l = document.createElement("a");
      l.href = href;
      return l;
    }
  },
  components: {
    // NotificationDropdownComponent,
    // UserDropdownComponent
  },
  computed: {

    colorOne() {
      let output =
          "text-blueGray-700 hover:text-blueGray-500 text-xs uppercase py-3 font-bold block";
      return output;
    },
    colorTwo() {
      let output =
          "text-pink-500 hover:text-pink-600 text-xs uppercase py-3 font-bold block";
      return output;
    },
    appName(){
      return globalParam.getAppName();
    },
    version(){
      return globalParam.getVersion();
    },
    isDevMode: function () {
      return abiService.isDevMode();
      // return true;
    },
  },
});
